<template>
  <basic-container>
    <div class="bankmanageDetail">
      <div class="bankdetail_title">
        <div class="banktail_">
          <Details
            :detaildeta="detaildeta"
            :data="data"
            :mySelf="userInfo.user_id == data.managerUser"
            manage="subfunds"
            @updatastate="updatastate"
            @quanxian="quanxian"
            @passcheck="passcheck"
            @changes="changes"
            @edit="edit"
          />
          <Detaillist
            :detaillist="detaillist"
            :data="data"
            @warningblock="warningblock"
          />

          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane class="activelabel" label="基金详情" name="first">
                <div class="informationxm">
                  <Usermanage
                    :auditState="data.auditState == 0 ? true : false"
                    :bankid="data.id"
                    :data="data"
                    @warningblock="warningblock"
                  />
                </div>
              </el-tab-pane>
              <!-- v-if="data.auditState >= 2" -->
              <el-tab-pane
                class="activelabel"
                label="项目信息"
                name="second"
              >
                <div class="informationxm">
                  <div class="form_wrapper">
                    <div class="form_header">
                      <div class="form_header_name">项目信息</div>
                      <div class="form_header_remarks"></div>
                    </div>

                    <ProjectDetail
                      ref="projectDetail"
                      :id="id"
                      :key="fullpath"
                    />
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                class="activelabel"
                label="动态列表"
                name="third"
              >
              <Item
                  title="动态信息"
                  :option="eventListOption"
                  :itemDate="eventList"
              />
               
              </el-tab-pane>
              <el-tab-pane class="activelabel" label="附件信息" name="fourth">
                <Accessory
                  idname="子基金文件"
                  fatername="子基金管理"
                  :showTitle="false"
                  :upload="
                    data.auditState == 0 &&
                    permission.fdoffunds_add &&
                    userInfo.user_id == data.managerUser
                  "
                  :projectid="data.id"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div>
        <Dialog :data="data" ref="dialogpass" />

        <History ref="history" @bankhistory="bankhistory"> </History>
      </div>
      <div>
        <el-dialog
      :close-on-click-modal="false"
          title="操作原因"
          :visible.sync="auditVisible"
          :modal-append-to-body="false"
          width="40%"
        >
          <el-form ref="auditForm" :model="auditForm" label-width="80px">
            <el-form-item
              label="原因描述"
              required
              prop="auditAdvise"
              :rules="[{ required: true, message: '原因描述不能为空' }]"
            >
              <el-input
                type="textarea"
                v-model="auditForm.auditAdvise"
                rows="3"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item style="text-align: center">
              <el-button type="primary" @click="onSubmitAudit">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <div class="history" v-if="data.orgId != -1 || data.newId != -1">
        <div class="history_content" @click="history">
          <div class="imagehistory">
            <el-image src="/img/bg/u3205.svg"></el-image>
          </div>

          <div class="text_history">历史版本</div>
        </div>
      </div>
    </div>
    <template><router-view :key="fullpath"></router-view></template>
  </basic-container>
</template>

<script>
import ProjectDetail from "./components/projectDetail";
import Usermanage from "./components/usermanage.vue";
import Accessory from "@/components/accessoriesother/accessory";
import Details from "@/components/detail/contract_currency/detail";
import Detaillist from "@/components/detail/contract_currency/detaillist";
import Dialog from "./components/dialog";
import History from "./components/history";
import Item from "./components/items.vue";
import * as dictionaries from "@/api/zd/dictionaries";
import * as api from "@/api/fund/subfunds";
import { queryEventLists } from "@/api/fund/fundProject";
import { mapGetters } from "vuex";

export default {
  name: "detail",
  data() {
    return {
      activeName: "first",
      data: {
        state: {},
      },
      eventList: [],
      eventListOption: {
        searchIcon: true,
        addBtn: false,
        delBtn: false,
        columnBtn: false,
        refreshBtn: false,
        editBtn: false,
        border: false,
        menu: false,
        align: "center",
        // fit: true,
        column: [
          {
            label: "动态名称",
            prop: "eventName",
            slot: true,
          },
          // {
          //   label: "审核状态",
          //   width: 200,
          //   prop: "auditStateLabel",
          // },
          {
            label: "动态编号",
            // width: 200,
            prop: "number",

            // slot: true,
          },
          {
            label: "日期",
            prop: "eventTime",
            // width: 200,
          },
          
        ],
      },
      butshengheloading: false,
      examine: true,
      auditVisible: false,
      auditForm: {
        auditAdvise: null,
      },
      detaildeta: {
        edit: "permission.fdoffunds_edit",
        // add: "permission.fdoffunds_add",
        // audit: "permission.fdoffunds_audit",
        title: "data.name",
        topclass: false
      },
      detaillist: {
        column: [
          {
            label: "设立时间",
            prop: "establishmentTime",
          },
          {
            label: "母基金",
            prop: "masterName",

            // dicUrl: "/api/blade-system/dict-biz/dictionary?code=collection_type",
          },
          // {
          //   label: "合作方式",
          //   prop: "cooperateType",
          //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
          // },
          // {
          //   label: "投后报告周期",
          //   prop: "manageCycle",
          //   dicUrl:
          //     "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
          // },
          {
            label: "基金管理人",
            prop: "manager.name",
          },

          {
            label: "基金规模",
            prop: "peScale",
            formatter: () => {
              return this.data.peScale == -1
                ? "-"
                : this.getMoney(this.data.peScale) + "元";
            },
          },
          {
            label: "基金实缴金额",
            prop: "totalCapitalPaid",
            formatter: () => {
              return this.data.totalCapitalPaid == -1
                ? "-"
                : this.getMoney(this.data.totalCapitalPaid) + "元";
            },
          },
          {
            label: "基金状态",
            prop: "fundState",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=fund_state",
          },
          // {
          //   label: "投资期截止日期",
          //   prop: "investEndDate",
          // },
          // {
          //   label: "退出期截止日期",
          //   prop: "quitEndDate",
          // },
        ],
        showcolumn: [
          {
            label: "审核状态",
            prop: "auditState",
            // show: "pageData.auditState==0",
            show: "pageData.auditState<-8",
            auditlog: true,
            state: 0,
            // state ：0  前面是否加上小圆点
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
          },
        ],
        firstsblock: {
          formatter: () => {
            return this.data.auditState >= "1" ? 23 : 19;
          },
        },
        sentersblock: {
          formatter: () => {
            return this.data.auditState >= "1" ? 1 : 5;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "40%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
      },
    };
  },
  components: {
    Usermanage,
    Accessory,
    Dialog,
    Details,
    Detaillist,
    History,
    ProjectDetail,
    Item,
  },
  watch: {
    $route(to, from) {
      this.id = this.$route.params.id;
      this.onLoad();
    },
    activeName: {
      handler(newName, oldName) {
        if (newName == "third") {
          this.queryEventList();
        }
      },
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.onLoad();
    if(this.$route['query']['active'] && this.$route['query']['active'] == 'list'){
      this.activeName = 'third'
    }
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
    fullpath: function () {
      return this.$route.query.fullpath;
    },
  },
  methods: {
    //获取详情
    onLoad() {
      api
        .getDetail(this.id)
        .then((res) => {
          this.$nextTick(() => {
            this.data = res.data.data;
            this.data.auditState = res.data.data.auditState;
            this.data.auditLog = res.data.data.auditLog
              ? JSON.parse(res.data.data.auditLog)
              : "";
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },
    queryEventList() {
      let self = this;
      let params = {
        projectId: this.id,
        // auditState: 2,
        firstNum: 0,
        num: 100,
        

      };
     
      // 不是经办人只能拿到审核通过的数据
      // if (this.userInfo.user_id == this.data.managerUser) {
      //   delete params.auditState;
      // }
      queryEventLists(params).then((res) => {
        // console.info(res, 'eventinvest')
        if (res["data"]["code"] == "200") {
          if (res["data"]["data"]["records"]["length"] > 0) {
            self.eventList = res["data"]["data"]["records"];
            self.eventList.map((item) => {
              item["eventName"] = `${item["projectName"]}-${
                item["eventType"] == 0
                  ? "股权投资"
                  : item["eventType"] == 1
                  ? "股权退出"
                  : "分红"
              }`;
              item.auditStateLabel =
                item.auditState == 0
                  ? "待提交"
                  : item.auditState == 1
                  ? "审核中"
                  : item.auditState == 2
                  ? "审核通过"
                  : "-";
            });
          }
        }
      });
    },
    goEventDetail(row) {
      // 路由跳转详情页
      this.$router.push({
        path: `/fund/investEventManage/detail/${row["id"]}`,
        query: {
          eventType: row["eventType"],
        },
      });
    },
    //编辑
    edit(id) {
      this.$router.push({ path: `/fund/subfunds/edit/${id}` });
    },
    //审核 原因
    warningblock() {
      this.$refs.dialogpass.showblock();
    },

    //历史合同
    history() {
      this.$refs.history.showhide(this.id);
    },
    //历史合同  查看
    bankhistory(id) {
      this.$router.push({
        path: `/fund/subfunds/detail/${id}`,
        query: {
          fullpath: Date.parse(new Date()),
        },
      });

      // this.id = this.$route.params.id;
      // this.onLoad();
    },

    //提交审核
    updatastate(type) {
      this.$confirm("是否确定提交审核?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.butshengheloading = true;
          api
            .submitaudit({ id: this.data.id })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.onLoad();
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //合同变更
    changes(id) {
      this.auditForm.pass = true;
      this.auditForm.type = "change";
      this.auditVisible = true;
    },
    // 审核权限  进行通过和退回弹框
    quanxian(id, type) {
      this.auditForm.pass = type;
      this.auditVisible = true;
    },
    // 审核权限  进行通过和退回保存
    onSubmitAudit() {
      this.$refs.auditForm.validate((vaild) => {
        if (vaild) {
          let data = {
            id: this.data.id,
            ...this.auditForm,
          };
          if (this.auditForm.type == "change") {
            // 变更
            data.modiReason = this.auditForm.auditAdvise;
            api.change(data).then((res) => {
              this.$router.push({
                path: `/fund/subfunds/edit/${res.data.data}`,
              });
            });
          } else {
            api.audit(data).then(
              (res) => {
                this.auditVisible = false;
                this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                this.onLoad();
                // this.$router.go(-1);
              },
              (error) => {
                window.console.log(error);
              }
            );
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bankmanageDetail {
  .bankdetail_title {
    background: #fff;
    padding-top: 0px !important;
    padding-bottom: 25px;
  }
  .history {
    position: absolute;
    top: 50%;
    right: 15px;
    display: flex;
    justify-content: center;
    z-index: 20;
    flex-direction: row;
    .history_content {
      width: 100px;
      font-size: 14px;
      cursor: pointer;
      height: 45px;
      display: flex;
      flex-direction: row;
      // justify-content: center;
      background: #409eff;
      line-height: 45px;
      color: #fff;
      // text-align: right;
      // padding-right: 15px;
      border-radius: 10px 0 0 10px;
      .imagehistory {
        text-indent: 5px;
        width: 35px;
        display: flex;
        justify-content: center;
        margin-right: 8px;
        flex: 1;
      }
      .text_history {
        flex: 2;
      }
    }
  }
  .banktail_ {
    width: 97%;
    min-width: 1100px;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      font-weight: bolder;
    }
    .changeblock {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .historyclass {
        background: #19be6b;
        padding: 5px 10px;
        font-size: 10px;
        border-radius: 0 10px 10px 0;
        margin-right: 10px;
        color: #fff;
      }
      .reds {
        background: #f56c6c;
      }
      .orange {
        background: #fec03d;
      }
    }
  }

  .bankcontent {
    position: relative;
    margin: 20px 0;
    .el-col {
      margin-bottom: 0px;
    }
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 14px;
      // margin-bottom: 5px;
      .el-form-item {
        margin-bottom: 0px;
      }

      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        justify-content: right;
        .list_top {
          flex: 1;
        }
        .towlist_top {
          text-align: right;
        }
        // .list_top:nth-last-of-type(1){
        //  text-align: right;
        // }

        .stateTop {
          color: rgb(187, 185, 185);
          text-indent: 12px;
        }
        .stateTop + div {
          color: #666666;
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}

.bankstate_0:before {
  background: #fec03d;
}
.bankstate_1:before {
  background: #51d351;
}
.bankstate_2:before {
  background: #ff7a8c;
}

.auditState_0:before {
  background: #fec03d;
}
.auditState_1:before {
  background: #409eff;
}
.auditState_2:before {
  background: #51d351;
}
.auditState_3:before {
  background: #51d351;
}
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 14px;
}
.bankmanageDetail .el-tabs__item.is-active {
  background: none;
}
.box_cards {
  height: 450px;
  overflow-y: auto;
}
.passblocksblock {
  // margin-top: 25px;
  text-align: right;
}

.checkcontract {
  cursor: pointer;
}
.detil_row {
  display: inline-block;
}
/deep/.el-form-item__label {
  color: #999999;
}
/deep/.el-tabs__header {
  margin: 0px;
}
.informationxm {
  margin-top: 20px;
}
.form_wrapper {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    border: 1px solid rgba(233, 233, 233, 1);
    background-color: rgba(249, 249, 249, 1);

    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 14px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
/deep/.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
/deep/.avue-crud__menu {
  display: none;
}
/deep/.avue-crud {
  width: 100%;
}
/deep/.avue-crud .el-table th {
  background-color: #ffffff;
  line-height: 50px;
  padding: 0;
}
/deep/.el-table .cell,
.el-table th > .cell {
  padding-left: 20px;
}
/deep/.el-table__empty-block {
  border-right: none;
}
.card_dtInfor .cell {
  padding-left: 20px !important;
}
.card_dtInfor .el-table th {
  background: #fff !important;
}
.card_dtInfor .el-table,
.card_dtInfor .el-table__empty-block {
  border: none !important;
}
.card_dtInfor .el-table::before {
  height: 0 !important;
}
.box_card {
  border-bottom: 0px;
}
/deep/ .el-table th {
  background: #fff;
  color: #333;
}
.blue-word{
    color: #409eff;
    cursor: pointer;
}
</style>

